export const SecurityPolicies = {
  "": "",
  "Title": "Manage Security Policies",
  "Policies": "Policies: ",
  "Name": "Name",
  "UntitledPolicy": "Untitled Policy",
  "CopySuffix": "copy{index}",
  "PolicyProperties": "Policy properties",
  "SecurityMethod": "Security Method: ",
  "PasswordProtection": "Password Protection",
  "CertificateProtection": "Certificate Protection",
  "PolicyName": "Policy Name: ",
  "Description": "Description: ",
  "Details": "Details: ",
  "EncryptedComponents": "Encrypted Components: ",
  "EncryptAllDocumentContents": "Encrypt all document contents",
  "ModificationDate": "Modification Date: ",
  "Printing": "Printing: ",
  "LowResolution": "Low Resolution(150 dpi)",
  "HighResolution": "High Resolution",
  "Accessibility": "Accessibility: ",
  "Copying": "Copying: ",
  "UserPassword": "User Password: ",
  "OwnerPassword": "Owner Password: ",
  "Required": "Required",
  "NotRequired": "Not Required",
  "Allowed": "Allowed",
  "NotAllowed": "Not Allowed",
  "Changes": "Changes: ",
  "InsertingDeleting": "Inserting, deleting, and rotating pages",
  "FillingForm": "Filling in forms and signing existing signature fields",
  "CommentingFillingForm": "Commenting, filling form, signing existing signature fields",
  "ExtractingPages": "Any except extracting pages",
  "None": "None",
  "EditDetails": "Edit Details...",
  "ApplyToThisDocument": "Apply to this document",
  "New": "New",
  "Copy": "Copy",
  "Delete": "Delete",
  "TipMethod": "Are you sure you want to change the encrypting method of the policy \"{name}\"?",
  "TipDelete": "Are you sure you want to delete the policy \"{name}\"?",
  "TipSameName": "A policy with this name already exists."
}